export function handleNavLinks(id) {
  const links = [...document.querySelectorAll('.c-nav__link--hero')]
  links.forEach((link) => {
    if (link.getAttribute('href').split('#')[1] == id) {
      link.classList.add('c-nav__link--active')
    } else {
      link.classList.remove('c-nav__link--active')
    }
  })
}
